export default {
  install: "Install Guide",
  message:
    "Receive personalized alerts for news, commits, transfers, and forum threads you care about.",
  title: "Get the New Rivals App"
};
